// src/components/GoogleAuthSuccess.js

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const GoogleAuthSuccess = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Obtenir le jeton depuis l'URL
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');

        if (token) {
            // Sauvegarder le jeton dans le stockage local
            localStorage.setItem('token', token);
            // Rediriger vers le tableau de bord
            navigate('/dashboard'); 
        } else {
            // Si le jeton est manquant, rediriger vers la page de connexion
            navigate('/login'); 
        }
    }, [navigate]);

    return (
        <div className="container">
            <h1 className="mt-5">Connexion réussie...</h1>
            <p>Redirection en cours...</p>
        </div>
    );
};

export default GoogleAuthSuccess;